/** Kitchen hub — same as digirasa-client `kRestaurantLatLnt`. */
export const KITCHEN_ORIGIN = { latitude: 17.51122, longitude: 78.3674 };

export const SELECTED_ADDRESS_STORAGE_KEY = 'digirasa_selected_address_id';

/**
 * @param {{ latitude: number, longitude: number }} origin
 * @param {{ latitude: number | null, longitude: number | null }} address
 * @returns {number | null} distance in km
 */
export function haversineKm(origin, address) {
  if (
    !origin ||
    !Number.isFinite(address.latitude) ||
    !Number.isFinite(address.longitude)
  ) {
    return null;
  }
  const toRad = (deg) => (deg * Math.PI) / 180;
  const earthKm = 6371;
  const dLat = toRad(address.latitude - origin.latitude);
  const dLng = toRad(address.longitude - origin.longitude);
  const lat1 = toRad(origin.latitude);
  const lat2 = toRad(address.latitude);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
  return earthKm * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

/**
 * @param {{ latitude?: number | null, longitude?: number | null }} address
 * @returns {number | null}
 */
export function distanceKmFromKitchen(address) {
  if (!address) return null;
  return haversineKm(KITCHEN_ORIGIN, {
    latitude: address.latitude,
    longitude: address.longitude,
  });
}

/**
 * @param {number | null | undefined} km
 * @returns {string}
 */
export function formatKitchenDistance(km) {
  if (!Number.isFinite(km)) return '';
  if (km < 0.1) return 'Less than 0.1 km from kitchen';
  return `${Number(km).toFixed(1)} km from kitchen`;
}

export function getStoredSelectedAddressId() {
  try {
    const value = window.localStorage.getItem(SELECTED_ADDRESS_STORAGE_KEY);
    return value ? Number(value) : null;
  } catch {
    return null;
  }
}

export function storeSelectedAddressId(id) {
  try {
    if (id == null) window.localStorage.removeItem(SELECTED_ADDRESS_STORAGE_KEY);
    else window.localStorage.setItem(SELECTED_ADDRESS_STORAGE_KEY, String(id));
  } catch {
    /* ignore */
  }
}

export function clearSelectedAddressId() {
  storeSelectedAddressId(null);
}
